<template>
    <div class="container-fluid w-100 h-100" style="overflow-x: hidden">
        <!-- Navbar -->
        <navbar :title="$t('area_defects.title')" class="mb-2"/>
        <div class="col-sm-12 nopads">
            <area-defect-search @search="fetchDefects" class="my-2"/>
            <area-defect-list
                :items="defects"
                @add="addDefect"
                @edit="editDefect"
                class="my-2"
            />
            <base-modal v-if="editMode" hide-header hide-footer size="lg" @close="showDefectList">
                <area-defect-editor
                    :defect="defect"
                    :is-observer="isObserver"
                    @close="showDefectList"
                    @closeAndUpdate="closeAndUpdate"
                />
            </base-modal>
            <div
                v-if="loading"
                id="loader"
                class="spinner"
            />
        </div>
    </div>
</template>

<script>
import AreaDefectList from './AreaDefectList'
import AreaDefectSearch from './AreaDefectSearch'
import {restApi} from '../../mixins/RestApiMixin'
import AreaDefectEditor from './AreaDefectEditor'
import {areaHelper} from '../../mixins/AreaMixin'
import Navbar from "@/components/utils/Navbar.vue";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'AreaDefects',
    components: {BaseModal, Navbar, AreaDefectList, AreaDefectEditor, AreaDefectSearch},
    mixins: [restApi, areaHelper],
    props: {
        isObserver: Boolean
    },
    data: function () {
        return {
            defects: [],
            defect: null,
            editMode: false,
            loading: false,
            areas: [],
            lastSearchedParams: null
        }
    },
    methods: {
        fetchDefects: function (params) {
            this.loading = true
            this.lastSearchedParams = params
            this.defects = []
            let url = null

            if (this.lastSearchedParams == null) {
                url = this.areaDefectOpenUrl
            } else if (this.lastSearchedParams.status === 1) {
                url = this.areaDefectOpenUrl
            } else {
                url = this.areaDefectUrl
            }
            this.restFetchParams(url, this.lastSearchedParams, this.handleResponse)
        },

        handleResponse: function (response) {
            this.defects = response.data
            this.loading = false
        },

        editDefect: function (defect) {
            this.defect = JSON.parse(JSON.stringify(defect))
            this.editMode = true
        },

        addDefect: function () {
            this.defect = this.newDefect()
            this.editMode = true
        },

        showDefectList: function () {
            this.editMode = false
        },

        closeAndUpdate: function () {
            this.showDefectList()
            this.fetchDefects(this.lastSearchedParams)
        }
    }
}
</script>

<style scoped>

</style>
